module.exports = __webpack_public_path__ + "static/media/angel-left-circle-thin.9f430f84.svg";